import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Icon as Icon$1 } from '../../display/Icon/Icon.es.js';
import { Spinner } from '../../display/Spinner/Spinner.es.js';
import { Icon } from '@zapier/zinnia-icons';
import { clsx } from 'clsx';
import React, { createContext, forwardRef } from 'react';
import { useContextProps } from 'react-aria-components';
import { ButtonBase } from '../ButtonBase/ButtonBase.es.js';

const button = "_button_werac_9";
const spinnerWrapper = "_spinner-wrapper_werac_28";
const fadeIn = "_fade-in_werac_1";
const content = "_content_werac_32";
const styles = {
	button: button,
	spinnerWrapper: spinnerWrapper,
	fadeIn: fadeIn,
	content: content
};

const ButtonContext = createContext(null);
const isIconElement = (element) => {
  return React.isValidElement(element) && (element.type === Icon || element.type === Icon$1);
};
const Button = forwardRef((_a, ref) => {
  var { children, className, iconPosition, isDisabled = false, isPending = false, variant = "primary" } = _a, otherProps = __rest(_a, ["children", "className", "iconPosition", "isDisabled", "isPending", "variant"]);
  const [contextProps] = useContextProps(otherProps, null, ButtonContext);
  const { size = "medium" } = contextProps, props = __rest(contextProps, ["size"]);
  const childrenArray = React.Children.toArray(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    typeof children === "function" ? children({}) : children
  );
  const hasIconStart = isIconElement(childrenArray[0]);
  const hasIconEnd = isIconElement(childrenArray[childrenArray.length - 1]);
  if ((hasIconStart || hasIconEnd) && !iconPosition) {
    console.warn('Button component detected an Icon, but `iconPosition` is missing.\nPlease pass `iconPosition="start"` or `iconPosition="end"` to align with design system expectations.');
  }
  return jsx(ButtonBase, Object.assign({}, props, { ref, className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx(styles.button, dynamicClassName);
  }, "data-has-icon-start": iconPosition === "start" || void 0, "data-has-icon-end": iconPosition === "end" || void 0, isDisabled: isDisabled || isPending, isPending, size, variant, children: (buttonRenderProps) => jsxs(Fragment, { children: [isPending && jsx("div", { className: styles.spinnerWrapper, children: jsx(Spinner, {}) }), jsx("div", { className: styles.content, children: typeof children === "function" ? children(buttonRenderProps) : children })] }) }));
});

export { Button, ButtonContext };
//# sourceMappingURL=Button.es.js.map
